/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { CashBoxTimeDeltaHistoryDto } from '../../../api/cashBoxes/cashBoxesClient.typings';
import {
    CashBoxTimeDeltaTabAction,
    CashBoxTimeDeltaTabActionType,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxTimeDeltaTabActions';

export interface CashBoxTimeDeltaTabState {
    cashBoxTimeDeltaHistory: CashBoxTimeDeltaHistoryDto;
    isLoadingTimeDeltaHistory: boolean;
    isDownloadingTimeDeltaHistory: boolean;
}
const initialState: CashBoxTimeDeltaTabState = {
    cashBoxTimeDeltaHistory: null,
    isLoadingTimeDeltaHistory: false,
    isDownloadingTimeDeltaHistory: false,
};

export function cashBoxTimeDeltaTabReducer(
    state: CashBoxTimeDeltaTabState = initialState,
    action: CashBoxTimeDeltaTabAction,
): CashBoxTimeDeltaTabState {
    switch (action.type) {
        case CashBoxTimeDeltaTabActionType.FETCH_CASHBOX_TIME_DELTA_HISTORY:
            return {
                ...state,
                isLoadingTimeDeltaHistory: true,
            };

        case CashBoxTimeDeltaTabActionType.FETCH_CASHBOX_TIME_DELTA_HISTORY_SUCCESS:
            return {
                ...state,
                isLoadingTimeDeltaHistory: false,
                cashBoxTimeDeltaHistory: action.payload,
            };

        case CashBoxTimeDeltaTabActionType.FETCH_CASHBOX_TIME_DELTA_HISTORY_ERROR:
            return {
                ...state,
                isLoadingTimeDeltaHistory: false,
                cashBoxTimeDeltaHistory: {
                    count: 0,
                    timeDeltas: [],
                },
            };

        case CashBoxTimeDeltaTabActionType.DOWNLOAD_TIME_DELTA_HISTORY:
            return {
                ...state,
                isDownloadingTimeDeltaHistory: true,
            };

        case CashBoxTimeDeltaTabActionType.DOWNLOAD_TIME_DELTA_HISTORY_SUCCESS:
        case CashBoxTimeDeltaTabActionType.DOWNLOAD_TIME_DELTA_HISTORY_ERROR:
            return {
                ...state,
                isDownloadingTimeDeltaHistory: false,
            };

        case CashBoxTimeDeltaTabActionType.EXIT_CASHBOX_TIME_DELTA_TAB:
            return {
                ...state,
                cashBoxTimeDeltaHistory: null,
            };

        default:
            break;
    }
    return state;
}
